import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { message } from "antd";
import { useAuthStore } from "../../stores/useAuthStore";
import { useMerchantStore } from "../../stores/useMerchantStore";

export function useAudits(data: { skip?: number; take?: number; reviewStatus: string }) {
  const authStore = useAuthStore();
  const merchantStore = useMerchantStore();

  return useQuery(["audits", data, merchantStore.selectedMerchant], async () => {
    if (!authStore.token || !merchantStore.selectedMerchant) return;

    const response = await axios.get<{ cars: []; total: number }>(
      `/backend/merchants/${merchantStore.selectedMerchant}/customer-cars`,
      {
        params: data,
      }
    );

    return response.data;
  });
}

export function useUpdateAudit() {
  const merchantStore = useMerchantStore();
  const queryClient = useQueryClient();

  return useMutation(
    ["audit", "update"],
    (data: { customerCarIds: number[] }) => {
      return axios.patch(`/backend/merchants/${merchantStore.selectedMerchant}/customer-cars/approve`, data);
    },
    {
      onSuccess: () => {
        message.success("審核成功");
        queryClient.invalidateQueries("audits");
      },
    }
  );
}
